import { CheckOutlined, SearchOutlined, UpOutlined } from "@ant-design/icons";
import { Button, Checkbox } from "antd";
import { InputHook } from "components/hook-forms";
import { ClearAllIcon } from "components/svgs/ClearAllIcon";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import "./AdminFilter.scss";

const FilterClient = ({ defaultValues, setShowFilter, handleClickFilter, onReset }) => {
  const {
    reset,
    control,
    formState: { errors },
    handleSubmit
  } = useForm({
    mode: "onSubmit",
    defaultValues: defaultValues
  });

  const [includeIndividuals, setIncludeIndividuals] = useState(
    defaultValues?.includeIndividuals || false
  );

  const submitForm = async (values) => {
    handleClickFilter({ ...values, includeIndividuals });
  };

  return (
    <div className="admin-filter">
      <form onSubmit={handleSubmit(submitForm)}>
        <div className="wrap-form-filter">
          <InputHook
            control={control}
            placeholder="Custom ID"
            label="Custom ID"
            name="custom_id"
            showOptionsName={false}
            errors={errors}
            suffix={<SearchOutlined />}
          />
          <InputHook
            control={control}
            placeholder="ID"
            label="ID"
            name="id"
            showOptionsName={false}
            errors={errors}
            suffix={<SearchOutlined />}
          />
          <InputHook
            control={control}
            placeholder="Company Name"
            label="Company Name"
            name="client_name"
            showOptionsName={false}
            errors={errors}
            suffix={<SearchOutlined />}
          />
          <div style={{ paddingTop: "8px" }}>
            <Checkbox
              checked={includeIndividuals}
              onChange={(e) => setIncludeIndividuals(e.target.checked)}
            >
              Include Individual Clients
            </Checkbox>
          </div>
        </div>
        <div className="wrap-button">
          <Button type="link" className="collapse" onClick={() => setShowFilter(false)}>
            Collapse <UpOutlined />
          </Button>
          <Button
            type="link"
            className="svg-icon clear"
            onClick={() => {
              reset();
              setIncludeIndividuals(false);
              onReset();
            }}
          >
            Clear <ClearAllIcon />
          </Button>
          <Button type="primary" htmlType="submit">
            Apply <CheckOutlined />
          </Button>
        </div>
      </form>
    </div>
  );
};
export default FilterClient;
